import type { SupabaseClient } from '@supabase/supabase-js'
import type { OnAuthStateChange } from '@/modules/auth/use-cases'
import { AuthUserMapper } from '../mappers'

export class SupabaseOnAuthStateChangeRepository {
  constructor(private readonly client: SupabaseClient) {}

  execute: OnAuthStateChange = (cb) => {
    const { data } = this.client.auth.onAuthStateChange((_event, session) => {
      cb(AuthUserMapper.toDomain(session))
    })
    return () => data.subscription.unsubscribe()
  }
}
